import type { ReactNode } from 'react';
import classNames from 'classnames';
import { Panel } from './export-image-drawer';
import type { ChartImageExporter, OutputFormat } from './types';
import styles from './export-push-drawer.module.scss';
// Reuse the drawer panel styling (sticky flex-sibling, animates to width 0 closed).
import drawerStyles from './export-image-drawer.module.scss';

export interface OpenExportPayload {
  exporter: ChartImageExporter;
  chartLabel: string;
  filenamePrefix: string;
  supportedFormats?: OutputFormat[];
}

interface ExportPushDrawerProps {
  // The active export target, or null when the drawer is closed.
  payload: OpenExportPayload | null;
  onClose: () => void;
  className?: string;
  children: ReactNode;
}

// Flex row hosting a chart (or group) beside a right-side push drawer that
// compresses it when open. Shared by ExportableHighchart and ChartExportSection.
export const ExportPushDrawer = ({
  payload,
  onClose,
  className,
  children,
}: ExportPushDrawerProps) => (
  <div className={classNames(styles.contentRow, className)}>
    <div className={styles.body}>{children}</div>
    <aside
      className={classNames(drawerStyles.panel, {
        [drawerStyles.panelClosed]: !payload,
      })}
      aria-hidden={!payload}
    >
      {payload && (
        <div className={drawerStyles.inner}>
          <Panel
            exporter={payload.exporter}
            chartLabel={payload.chartLabel}
            filenamePrefix={payload.filenamePrefix}
            supportedFormats={payload.supportedFormats ?? ['png']}
            onClose={onClose}
          />
        </div>
      )}
    </aside>
  </div>
);
